<template>
  <div class="room-setting-content-component">
    <perfect-scrollbar class="h-full" ref="scrollbar">
      <component :is="settingComponent" ref="component" @onUpdateScroll="onUpdateScroll"/>
    </perfect-scrollbar>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  props: ['isSelected'],
  components:{
    "General": () => import('@/components/Room/SettingRenew/Contents/General.vue'),
    "Join": () => import('@/components/Room/SettingRenew/Contents/Join.vue'),
    "Quality": () => import('@/components/Room/SettingRenew/Contents/Quality.vue'),
    "Chat": () => import('@/components/Room/SettingRenew/Contents/Chat.vue'),
    "Display": () => import('@/components/Room/SettingRenew/Contents/Display.vue'),
    "Streaming": () => import('@/components/Room/SettingRenew/Contents/Streaming.vue'),
    "Group": () => import('@/components/Room/SettingRenew/Contents/Group.vue'),
    "Share": () => import('@/components/Room/SettingRenew/Contents/Share.vue'),
    "Etc": () => import('@/components/Room/SettingRenew/Contents/Etc.vue')
  },
  data(){
    return{
      settingComponent: '',
    }
  },
  computed:{
    ...mapGetters('user', [
      'hasEmceeRole'
    ]),
    roomTitle(){
      if(this.settingComponent !== 'General') return;
      return this.$refs.component.roomTitle;
    },
    password(){
      if(this.settingComponent !== 'General') return;
      return this.$refs.component.roomPassword;
    },
    isPublic(){
      return this.$refs.component.isPublic;
    },
    enterRole(){
      if(this.settingComponent !== 'Join') return;
      return this.$refs.component.enterRole
    },
    joinDevice(){
      if(this.settingComponent !== 'Join') return;
      return this.$refs.component.joinDevice
    },
    isCameraOn(){
      if(this.settingComponent !== 'Join') return;
      return this.$refs.component.isCameraOn
    },
    isMicOn(){
      if(this.settingComponent !== 'Join') return;
      return this.$refs.component.isMicOn
    },
    isResetRole(){
      if(this.settingComponent !== 'Join') return;
      return this.$refs.component.isResetRole
    },
    useWaitingRoom(){
      if(this.settingComponent !== 'Join') return;
      return this.$refs.component.useWaitingRoom
    },
    isDeviceRequired(){
      if(this.settingComponent !== 'Join') return;
      return this.$refs.component.isDeviceRequired
    },
    isChatMode(){
      if(this.settingComponent !== 'Chat') return;
      return this.$refs.component.isChatMode
    },
    displayQuality(){
      if(this.settingComponent !== 'Quality') return;
      return this.$refs.component.selectedQuality
    },
    params(){
      return {
        roomTitle : this.roomTitle,
        password: this.password,
        enterRole: this.enterRole,
        joinDevice: this.joinDevice,
        isCameraOn: this.isCameraOn,
        isMicOn: this.isMicOn,
        isResetRole: this.isResetRole,
        useWaitingRoom: this.useWaitingRoom,
        isDeviceRequired: this.isDeviceRequired,
        isChatMode: this.isChatMode,
        displayQuality: this.displayQuality
      }
    }
  },
  watch:{
    isSelected(){
      switch(this.isSelected){
        case 'general':
          this.settingComponent = 'General';
          break;
        case 'join':
          this.settingComponent = 'Join';
          break;
        case 'quality':
          this.settingComponent = 'Quality';
          break;
        case 'chat':
          this.settingComponent = 'Chat';
          break;
        case 'display':
          this.settingComponent = 'Display';
          break;
        case 'streaming':
          this.settingComponent = 'Streaming';
          break;
        case 'group':
          this.settingComponent = 'Group';
          break;
        case 'share':
          this.settingComponent = 'Share';
          break;
        case 'etc':
          this.settingComponent = 'Etc';
          break;
      }
    }
  },
  created() {
    this.initSettingComponent();
  },
  methods: {
    initSettingComponent(){
        this.settingComponent = this.hasEmceeRole() ? 'General' : 'Etc'
    },
    onUpdateScroll(){
      this.$nextTick(async () => {
        this.$refs.scrollbar.update();
      })
    },
  },
}
</script>

<style lang='scss' scoped>
.room-setting-content-component{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 450px;
  border-left: 1px solid #c8c8c8;
}

[grm-device-mobile]{
  .room-setting-content-component{
    max-height: none;
    flex: 1;
  }
}
</style>